module.exports = __webpack_public_path__ + "img/ShafiqiHaji.273f54da.jpg";